import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { toastr } from "react-redux-toastr";

import { FormActionTypes, validationSchema, ValueTypes, VALUE } from "./formSettings";

import { FormComponent } from "./FormComponent";

import { closeModal } from "../../../store/modules/modal/actions";
import { getActiveInstance } from "../../../store/modules/library/selectors";
import { getUser } from "../../../store/modules/session/selectors";

import { createFolder } from "../../../utils/createFolder";
import { createDBPath, errorList, folderSchema } from "../../../utils/Instance";

export const AddFolder: React.FC = () => {
  const user = useSelector(getUser);
  const instance = useSelector(getActiveInstance);
  const dispatch = useDispatch();

  const handleOnSubmit = useCallback((values: ValueTypes, actions: FormActionTypes) => {
    try {
      const validData = folderSchema.validateSync({ instance, user });
      const DBPath = createDBPath(validData);

      createFolder(values.title, DBPath)
        .then(() => {
          dispatch(closeModal());
        })
        .catch(({ message }: Error) => {
          actions.setStatus(message);
          toastr.error("Create Folder", message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    } catch ({ message }) {
      const error = errorList[message] || ["Create Folder", message];

      toastr.error(...error);
      actions.setStatus(error[0]);
      actions.setSubmitting(false);
    }
  }, [user, instance, dispatch]);

  return instance && (
    <Formik
      initialValues={VALUE}
      validationSchema={validationSchema}
      onSubmit={handleOnSubmit}
      component={FormComponent}
      enableReinitialize
    />
  );
};
